import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaTherapist, updateTuinaTherapist } from '@/service/tuina'
import TherapistForm from './TherapistForm'

const fromValue = (fields) => {
  const { avatar, ...rest } = fields
  const avatarList = Array.isArray(avatar) ? avatar : []
  const avatarItem = avatarList[0]
  const originFileObj = avatarItem && avatarItem.originFileObj
  if (!originFileObj) return rest
  return {
    ...rest,
    avatar: originFileObj
  }
}

class TherapistModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    actType: 'create'
  }

  handleOk = async (form) => {
    const { actType, record, onSuccess } = this.props
    const fields = await form.current.validateFields()
    const formatFields = fromValue(fields)

    switch (actType) {
      case 'create':
        await createTuinaTherapist(formatFields)
        message.success('已新增')
        break
      case 'edit':
        await updateTuinaTherapist(record.id, formatFields)
        message.success('已保存')
        break
      default:
        return
    }
    onSuccess()
  }

  render () {
    const { children, actType, record } = this.props
    const therapistName = (record && record.name) || ''
    const title = actType === 'edit' ? `编辑 ${therapistName} 师傅` : '新增师傅'
    return (
      <WrappedModal
        children={children}
        title={title}
        okText={actType === 'edit' ? '保存' : '新增'}
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        baseComponent={<TherapistForm />}
        baseProps={{ actType, record }}
        onOk={this.handleOk}
      />
    )
  }
}

export default TherapistModal
